
define('C25.Blog.View'
	, [
		'CustomContentType.Base.View'

		, 'c25_blog.tpl'

		, 'jQuery'
		, 'underscore'

		, 'Tools'
	]
	, function (
		CustomContentTypeBaseView

		, c25_blog_tpl

		, jQuery
		, _

		, Tools
	) {
		'use strict';

		return CustomContentTypeBaseView.extend({

			template: c25_blog_tpl
			,
			initialize: function () {
				
			}
			, getContext: function getContext() {

				console.log("settings", this.settings);
			
				return this.settings;
			}
		});
	});
